export default {"src":"/_next/static/media/pro-promise-verify.c0cd8500.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};